import type { RequestException } from '@eika-infrastruktur/request';
import type { CreateShareSavingsAccountForChildProcessRules } from '@generated-types';
import { getAccountForChildProcessRules } from '@react-query/services/account-for-child-process-rules';
import { useQuery } from '@tanstack/react-query';

export const useAccountForChildProcessRules = () =>
    useQuery<CreateShareSavingsAccountForChildProcessRules, RequestException>({
        queryKey: ['account-for-child-process-rules'],
        queryFn: () => getAccountForChildProcessRules(),
    });
